import { render, staticRenderFns } from "./BaseFormGroup.vue?vue&type=template&id=1bdfebac&scoped=true"
import script from "./BaseFormGroup.vue?vue&type=script&lang=js"
export * from "./BaseFormGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroup.vue?vue&type=style&index=0&id=1bdfebac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdfebac",
  null
  
)

export default component.exports